import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ variant = "navy", className = "" }) => {
  const src =
    variant === "white" ? "/leduro_logo_white.png" : "/leduro_logo.png";
  return (
    <Link
      to="/"
      data-testid="logo-link"
      className={`inline-flex items-center ${className}`}
      aria-label="Leduro home"
    >
      <img
        src={src}
        alt="Leduro"
        className="h-8 md:h-9 w-auto select-none"
        draggable={false}
      />
    </Link>
  );
};

export default Logo;
